import Loading from '../../../Common/Loading';
import { AverageFamilyIncome } from './AverageFamilyIncome';
import { FamilyBudget } from './FamilyBudget';
import { FamilyIncome } from './FamilyIncome';
import { IncomeRange } from './IncomeRange';
import { Indicators } from './Indicators';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const Charts = () => {
    const { isLoading } = useHouseholdIncomeChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <IncomeRange />
                <FamilyBudget />
            </div>
            <div className="charts-side-by-side-dashboards">
                <FamilyIncome />
                <AverageFamilyIncome />
            </div>
        </>
    );
};
